// -----------------------------------------------------------
// FloraIQ — Drawer de Detalhe da Inconsistência
// -----------------------------------------------------------

import { inconsistencyDetailExample } from "@/mocks/quality";
import { SeverityBadge, ValidationStatusBadge } from "./QualityStatusBadge";

interface InconsistencyDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function InconsistencyDetailDrawer({ isOpen, onClose }: InconsistencyDetailDrawerProps) {
  if (!isOpen) return null;

  const d = inconsistencyDetailExample;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-black/30 fade-in" onClick={onClose}></div>
      <div className="relative bg-white w-full max-w-lg h-full overflow-y-auto slide-in-from-right shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-background-200/70 sticky top-0 bg-white z-10">
          <h3 className="text-sm font-semibold font-heading text-foreground-900">Detalhe da Inconsistência</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-foreground-500"></i>
          </button>
        </div>

        <div className="p-4 space-y-5">
          {/* Cabeçalho */}
          <div className="flex items-center gap-2">
            <SeverityBadge severity={d.severidade} />
            <ValidationStatusBadge status="pendente" />
          </div>

          <h4 className="text-base font-semibold font-heading text-foreground-900">{d.regraViolada}</h4>
          <p className="text-sm text-foreground-600">{d.descricao}</p>

          {/* Cards de informação */}
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-background-50 rounded-card p-3 border border-background-200/70">
              <p className="text-xs text-foreground-500 mb-1">Unidade Afetada</p>
              <p className="text-sm font-medium text-foreground-800 font-mono">{d.unidadeAfetada}</p>
            </div>
            <div className="bg-background-50 rounded-card p-3 border border-background-200/70">
              <p className="text-xs text-foreground-500 mb-1">Responsável</p>
              <p className="text-sm font-medium text-foreground-800">{d.responsavel}</p>
            </div>
          </div>

          {/* Dados atuais vs esperados */}
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-card p-3 border border-red-200 bg-red-50/40">
              <p className="text-xs text-red-600 font-medium mb-1">Dados Atuais</p>
              <p className="text-xs text-foreground-600">{d.dadosAtuais}</p>
            </div>
            <div className="rounded-card p-3 border border-green-200 bg-green-50/40">
              <p className="text-xs text-green-600 font-medium mb-1">Dados Esperados</p>
              <p className="text-xs text-foreground-600">{d.dadosEsperados}</p>
            </div>
          </div>

          {/* Fonte e Histórico */}
          <div className="bg-background-50 rounded-card p-3 border border-background-200/70">
            <p className="text-xs text-foreground-500 mb-1">Fonte Relacionada</p>
            <p className="text-sm text-foreground-700">{d.fonteRelacionada}</p>
          </div>
          <div className="bg-background-50 rounded-card p-3 border border-background-200/70">
            <p className="text-xs text-foreground-500 mb-1">Histórico</p>
            <p className="text-sm text-foreground-700">{d.historico}</p>
          </div>

          {/* Ação Recomendada */}
          <div className="bg-blue-50/60 border border-blue-200/60 rounded-card p-3">
            <div className="flex items-start gap-2">
              <div className="w-7 h-7 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-lightbulb-line text-blue-600 text-xs"></i>
              </div>
              <div>
                <p className="text-xs font-medium text-blue-700 mb-0.5">Ação Recomendada</p>
                <p className="text-xs text-blue-600">{d.acaoRecomendada}</p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-card p-3 border border-background-200/70">
            <p className="text-xs text-foreground-500 mb-1">Prazo Sugerido</p>
            <p className="text-sm font-medium text-foreground-800">{d.prazoSugerido}</p>
          </div>

          {/* Ações */}
          <div className="flex flex-wrap gap-2 pt-2">
            <button className="btn-primary text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
              <i className="ri-check-line mr-1"></i> Corrigir
            </button>
            <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
              <i className="ri-error-warning-line mr-1"></i> Criar Exceção
            </button>
            <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
              <i className="ri-user-3-line mr-1"></i> Atribuir
            </button>
            <button className="btn-outline text-xs px-3 py-2 cursor-pointer whitespace-nowrap">
              <i className="ri-external-link-line mr-1"></i> Abrir Registro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}